/** Format view counts like Telegram (1.2K, 3.4M). */
export function formatViews(count) {
  const n = Number(count) || 0;
  if (n < 1000) return String(n);
  if (n < 10000) {
    const v = Math.round(n / 100) / 10;
    return `${v}K`.replace('.0K', 'K');
  }
  if (n < 1000000) {
    return `${Math.round(n / 1000)}K`;
  }
  const v = Math.round(n / 100000) / 10;
  return `${v}M`.replace('.0M', 'M');
}

export default formatViews;
